import { render, staticRenderFns } from "./SampleMeasureActionsCellRenderer.vue?vue&type=template&id=53508be2"
import script from "./SampleMeasureActionsCellRenderer.vue?vue&type=script&lang=js"
export * from "./SampleMeasureActionsCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports